/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { NumberInput } from '../../../../../components/inputs/NumberInput';
import { StepProps } from './AddEditReceipt';

export const ReceiptForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Receipt Details" showRequiredLegend={!readOnly} />
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="store_name"
          >
            <FormLabel required>Store Name</FormLabel>
            <Field
              name="store_name"
              as={Form.Control}
              isInvalid={touched.store_name && !!errors.store_name}
              aria-required
            />
            <ErrorMessage name="store_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="total"
          >
            <FormLabel required>Total</FormLabel>
            <Field
              name="total"
              as={NumberInput}
              isInvalid={touched.total && !!errors.total}
              aria-required
            />
            <ErrorMessage name="total">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
